import { Injectable } from '@angular/core';
import { SEARCH_KEYS } from 'app/constants';
import { HttpStatusCode } from 'app/shared/models/http-status-code.constants';
import { AlertService, ConfirmDialogService, ResourceService } from 'sce-core';
import { SearchService } from 'app/shared/search/search.service';
import { SerialNumberPopupBackendService } from './serial-number-popup-backend.service';

@Injectable()
export class SerialNumberPopupActionService {
  lookupSearchService: SearchService;
  tableId: string = '';
  receiptKey: string = '';

  constructor(
    protected resourceService: ResourceService,
    protected alertService: AlertService,
    protected confirmDialogService: ConfirmDialogService,
    protected backendService: SerialNumberPopupBackendService,
  ) { }

  initializeService(
    lookupSearchService: SearchService,
    tableId: string,
    receiptKey: string
  ) {
    this.lookupSearchService = lookupSearchService;
    this.tableId = tableId;
    this.receiptKey = receiptKey;
  }
  
  deleteSearchLineItem() {
    const requestItemsList = [];
    const selectedData = this.lookupSearchService.getSelectedRows();

    selectedData.forEach((row: any, index: any) => {
      const selectedLineItem = [];
      Object.keys(row.cells).forEach((property: any) => {
        const cell = row.cells[property];
        selectedLineItem.push({ cName: property, cVal: cell.cVal });
      });
      const request = {
        'moduleProperties': selectedLineItem,
        'screenType': this.lookupSearchService.searchParams.tableId
      };
      requestItemsList.push(request);
    });
    if (requestItemsList.length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('select_one_row'));
      return;
    }
    const confMsg = this.resourceService.get('msg_itm_conf_del')
          .replace('{}', this.resourceService.get('lbl_serial_number'));
    this.confirmDialogService.confirmDialog(confMsg)
      .subscribe((isConfirmed: any) => {
        if (isConfirmed) {
          this.backendService.deleteEntities(requestItemsList).subscribe((resp: any) => this.handleHttpResponse(resp, 'msg_del_itm_succ'),
          (error: any) => {
            this.alertService.clearAll().error(this.resourceService.get(error));
          });
        }
      });
  }

  deleteAllLineItems() {
    const confMsg = this.resourceService.get('msg_del_itm_all')
      .replace('{}', this.resourceService.get('lbl_serial_number'));
    this.confirmDialogService.confirmDialog(confMsg)
      .subscribe((confirmed) => {
        if (confirmed) {
          const request = [{
            'screenType': this.tableId,
            'moduleProperties': [{
              cName: SEARCH_KEYS.RECEIPT_KEY,
              cVal: this.receiptKey
            }, { cName: 'isDeleteAllItem', 'cVal': true }],
          }];
          this.backendService.deleteEntities(request)
            .subscribe((resp: any) => this.handleHttpResponse(resp, 'msg_del_all_succ'),
            (error: any) => {
              this.alertService.clearAll().error(this.resourceService.get(error));
            });
        }
      });
  }

  save() {
    const editedLineItems = [];
    const selectedData = this.lookupSearchService.getEditedRows();
    const typeName = 'original_';
    const metadata = this.lookupSearchService.getMetadata();
    let hasInvalidCells = false;

    selectedData.forEach((row: any, index: any) => {
      const selectedLineItem = [];
      Object.keys(row.cells).forEach((property: any) => {
        const cell = row.cells[property];
        // Validate cells with displayType 'E' are not empty
        if (metadata && metadata.columnList) {
          const columnMeta = metadata.columnList.find((col: any) => col.propertyName === property);
          const invalidValue = (
            columnMeta && columnMeta.displayType === 'E' &&
            (cell.cVal === null || cell.cVal === undefined ||
            (typeof cell.cVal === 'string' && cell.cVal.trim() === ''))
          )
          if (invalidValue) {
            cell.isValueInvalid = true;
            hasInvalidCells = true;
          } else {
            cell.isValueInvalid = false;
          }
        }
        selectedLineItem.push({ cName: typeName + property, cVal: cell.cValOrig });
        selectedLineItem.push({ cName: property, cVal: cell.cVal });
      });
      const request = {
        'moduleProperties': selectedLineItem,
        'screenType': this.lookupSearchService.searchParams.tableId
      };
      editedLineItems.push(request);
    });

    if (hasInvalidCells) {
      this.alertService.clearAll().error(this.resourceService.get('err_msg_val_prop').replace(/%/g, this.resourceService.get('serialNo')));
      return false;
    }

    if (editedLineItems.length === 0) {
      this.alertService.clearAll().warn(this.resourceService.get('msg_no_mod'));
      return true;
    }

    this.backendService.saveEntityforUpdate(editedLineItems).subscribe(
      (resp: any) => this.handleHttpResponse(resp, 'msg_save_succ'),
      (error: any) => {
        this.alertService.clearAll().error(this.resourceService.get(error));
      }
    );
    return true;
  }

  handleHttpResponse(resp: any,successMsgKey: string){
    if (resp['statusCode'] && resp['statusMessage']) {
      if (resp['statusCode'] === HttpStatusCode.ok) {
        this.lookupSearchService.performSearch();
        this.alertService.success(this.resourceService.get(successMsgKey));
      }
    } else if (resp.error) {
      this.alertService.clearAll();
      this.alertService.error(this.resourceService.get(resp.error));
    }
  }
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/serial-number-popup/services/serial-number-popup-action.service.ts